<script setup lang="ts">
import { Color } from "~/core/models/Color.enum";
import { capitalizeFirstLetter } from "~/core/utils/string-tools";
import { DtwinOperationStatus } from "~/modules/dtwin/models/DtwinOperationStatus.enum";

const props = defineProps<{
  status: DtwinOperationStatus;
}>();

const { t, te } = useI18n();

const badgeType = computed(() => {
  switch (props.status) {
    case DtwinOperationStatus.DELIVERED:
    case DtwinOperationStatus.RETRY:
    case DtwinOperationStatus.RUNNING:
      return Color.PRIMARY;
    case DtwinOperationStatus.CANCELLING:
    case DtwinOperationStatus.ON_HOLD:
      return Color.WARNING;
    case DtwinOperationStatus.DONE:
      return Color.SUCCESS;
    case DtwinOperationStatus.CANCELLED:
    case DtwinOperationStatus.EXPIRED:
    case DtwinOperationStatus.FAILED:
      return Color.DANGER;
    case DtwinOperationStatus.PENDING:
    case DtwinOperationStatus.QUEUED:
    case DtwinOperationStatus.SCHEDULED:
    default:
      return Color.SECONDARY;
  }
});
</script>

<template>
  <lxc-badge :type="badgeType" :text-white="badgeType === 'primary'">
    {{
      status
        ? te(`operation.${status.toLowerCase()}`)
          ? t(`operation.${status.toLowerCase()}`)
          : capitalizeFirstLetter(status)
        : t("operation.unknown")
    }}
  </lxc-badge>
</template>
